exports.components = {
  "component---src-pages-console-js": () => import("./../../../src/pages/console.js" /* webpackChunkName: "component---src-pages-console-js" */),
  "component---src-templates-api-tsx": () => import("./../../../src/templates/api.tsx" /* webpackChunkName: "component---src-templates-api-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-release-notes-tsx": () => import("./../../../src/templates/release-notes.tsx" /* webpackChunkName: "component---src-templates-release-notes-tsx" */)
}

